import { IAutocompleteMatch } from "@directives/_forms/autocomplete/autocomplete.component";
import { IFileUploadDetails } from "@directives/_forms/fileUpload/fileUpload.component";
import { ExternalReferenceService } from "@directives/_veri/externalReference/externalReference.service";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { DriverAssignmentSource } from "@enums/DriverAssignmentSource.enum";
import { SortType } from "@enums/SortType";
import { IDriver } from "@interfaces/IDriver";
import { IGeofence } from "@interfaces/IGeofences";
import { IVehicle } from "@interfaces/IVehicle";
import { IVehicleDriverMapping } from "@interfaces/IVehicleDriverMapping";
import { DriverService } from "@services/driver.service";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { GeofenceService } from "@services/geofence.service";
import { GroupService } from "@services/group.service.ajs";
import { MessageDialogService } from "@services/messageDialog.service";
import { TranslationService } from "@services/translation.service";
import { ValidationService } from "@services/validation.service";
import { VehicleService } from "@services/vehicle.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import * as moment from "moment";
import { IGroupWithIds } from "../groups/_models/IGroupWithIds";
import "./driverassignment.scss";

interface IDriversBindings {
    onDriversChanged: () => void;
}

export class Driver implements IDriver {
    Password: string;
    Name: string;
    Username: string;
    ButtonId: string;
    Id: number;

    constructor() {
        this.Id = 0;
        this.Name = "";
        this.Password = "";
        this.Username = "";
        this.ButtonId = "";
    }
}

export class DriversComponentController implements IDriversBindings, angular.IComponentController {
    onDriversChanged: () => void;


    DriverAssignmentSource = DriverAssignmentSource;

    saving = false;
    loading = false;

    displayDrivers: IDriver[];
    vehicles: IVehicle[];
    groups: IGroupWithIds[];
    assignments: IVehicleDriverMapping[];

    selectedGroups: IGroupWithIds[];

    // End date combo box type, 0 for Permanent 1 for specific end Date
    endDateType: number;
    endDate: Date;
    endTime: Date;

    selectedDriver: IDriver;

    currentAssignment: IVehicleDriverMapping;
    originalAssignment: IVehicleDriverMapping;

    assignmentChanged: boolean;
    assignmentChanges: string[] = [];

    duplicateDriverName = false;
    existingDriverUsernames: string[] = [];

    cancelChanges = false;
    driverFormInvalid: boolean;

    minEndDate: Date;


    editDriverForm: angular.IFormController;
    imageHasChanged: boolean;
    dataChanged: boolean;
    allowSave: boolean;

    driverImageFile: File;
    driverImage: string;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<IDriver>[];

    geofences: IGeofence[];

    permanentDate = moment(new Date(2200, 0, 1));

    vehicleAssigned: boolean;
    driverName: string;

    static $inject = ["$q", "$mdDialog", "driverService", "driverAssignmentService", "messageDialogService", "vehicleService", "groupService", "externalReferenceService", "veriDate", "geofenceService", "veriTableService", "translationService", "validationService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly driverService: DriverService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly messageDialogService: MessageDialogService,
        private readonly vehicleService: VehicleService,
        private readonly groupService: GroupService,
        private readonly externalReferenceService: ExternalReferenceService,
        private readonly veriDate: VeriDate,
        private readonly geofenceService: GeofenceService,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService,
        private readonly validationService: ValidationService
    ) {
    }

    $onInit(): void {
        this.loadData();

        this.minEndDate = moment().add(1, 'd').toDate();

        this.tableHeaders = [
            this.veriTableService.createVehicleRegHeader(),
            { title: this.translationService.t("Common.Name"), sortable: true },
            { title: this.translationService.t("driverAssignment.dbCardNumber"), sortable: true, width: 180 },
            { title: this.translationService.t("driverAssignment.assignmentEnd"), sortable: true, width: 160, sortType: SortType.Number },
            { title: this.translationService.t("Common.Groups"), sortable: false, sortType: SortType.Number, excludeFromExport: true },
            { title: this.translationService.t("driverAssignment.externalReference"), hide: true },
            { title: this.translationService.t("driverAssignment.username"), hide: true },
            { title: this.translationService.t("driverAssignment.nfcTag"), hide: true }
        ];
    }

    onTagsChanged(): void {
        this.verifyData(true);
    }

    addDriver(): void {
        this.selectDriver(new Driver());

        this.driverFormInvalid = true;
        this.verifyData();
    }

    reactivateDriver() {
        this.loading = true;
        this.driverService.reactivateDriver(this.selectedDriver).then(() => {
            this.selectedDriver = null;
        })
            .catch(err => {
                this.messageDialogService.handleError(err, this.translationService.t("driverAssignment.UnableToReactivate"))
            })
            .finally(() => {
                this.loadData();

                this.loading = false;
            });
    }

    deactivateDriver() {
        this.driverService.deactivateDriver(this.selectedDriver).then(() => {
            this.selectedDriver = null;
            this.loadData();
        })
            .catch(err => {
                this.messageDialogService.handleError(err, this.translationService.t("driverAssignment.UnableToDeactivate"))
            });
    }

    onAssignmentEndTypeChanged() {

        if (this.endDateType == 0) {
            this.currentAssignment.EndUtc = this.driverAssignmentService.getAssignmentPermanentDate(false);
        }
        else {
            var endMoment = moment().add(1, "day").minute(0).hour(0);
            this.currentAssignment.EndUtc = endMoment;
            this.endDate = endMoment.toDate();
            this.endTime = endMoment.startOf('day').toDate();

            this.updateCurrentAssignmentModel();
        }

        this.assignmentChanged = true;
    }

    onAssignmentEndChanged() {

        const assignmentEnd = moment(this.endDate);
        assignmentEnd.set("hour", parseInt(this.endTime.getHours().toString()));
        assignmentEnd.set("minute", parseInt(this.endTime.getMinutes().toString()));
        assignmentEnd.set("second", 0);
        assignmentEnd.set("millisecond", 0);

        this.currentAssignment.EndUtc = assignmentEnd;

        this.updateCurrentAssignmentModel();
    }

    endAssignment() {
        this.selectedDriver.vehicle = null;
    }

    onDriverImageCleared() {
        this.driverImage = null;
        this.setImageHasChanged(true);

        this.verifyData();
    }

    onDriverImageChanged(fileUploadDetails: IFileUploadDetails) {
        this.driverImage = fileUploadDetails.fileString;
        this.setImageHasChanged(true);

        this.verifyData();
    }

    saveClicked(): angular.IPromise<void> {
        this.saving = true;

        return this.driverService.updateDriver(this.selectedDriver, false)
            .then((driverId => {

                return this.saveAdditionalData(driverId).then(() => {
                    this.selectedDriver = null;

                    this.loadData();

                });
            }))
            .catch(err => {
                this.messageDialogService.handleError(err, this.translationService.t("driverAssignment.UnableToEdit"))
            })
            .finally(() => {
                this.saving = false;
            });
    }

    saveAdditionalData(driverId: number): angular.IPromise<any[]> {
        var promises: angular.IPromise<any>[] = [];
        let assignmentUpdatePromise = this.$q.resolve();

        if (this.assignmentChanged && this.currentAssignment) {
            this.currentAssignment.DriverId = driverId;
            const newAssignment = {
                ...this.currentAssignment,
                Id: null
            }
            assignmentUpdatePromise = this.driverAssignmentService.saveDriverAssignment(newAssignment);
        }
        else if (this.assignmentChanged && !this.currentAssignment && this.originalAssignment) {
            this.originalAssignment.EndUtc = moment();
            assignmentUpdatePromise = this.driverAssignmentService.endDriverAssignment(this.originalAssignment);
        }

        promises.push(assignmentUpdatePromise);

        if (this.imageHasChanged) {
            promises.push(this.driverService.saveDriverImage(driverId, this.driverImage));
        }

        return this.$q.all(promises);
    }

    selectedDriverChanged() {
        this.driverFormInvalid = this.editDriverForm.$invalid;
        this.verifyData();
    }

    selectDriver(driver: IDriver): void {
        this.reset();

        if (driver == null) {
            return;
        }

        this.selectedDriver = copy(driver);
        this.selectedGroups = copy(this.groups);

        this.currentAssignment = copy(this.selectedDriver.currentAssignment);
        this.originalAssignment = copy(this.selectedDriver.currentAssignment);

        // Driver assignments dont have DriverId on for some reason

        // stops a circular reference
        //this.selectedDriver.vehicle = null;

        if (this.selectedDriver.Email) {
            this.selectedDriver.Email = this.selectedDriver.Email.trim();
        }

        if (this.selectedDriver.Mobile) {
            this.selectedDriver.Mobile = this.selectedDriver.Mobile.trim();
        }

        this.updateEndDateType();

        this.driverImage = null;
        this.driverImageFile = null;
        this.driverService.getDriverImage(this.selectedDriver).then(image => this.driverImage = image);

        this.assignDriverGroupIds();

        this.verifyData();
        this.updateAssignmentChangedState();
    }

    selectedVehicleChanged($match: IAutocompleteMatch) {
        var newData = false;
        this.vehicleAssigned = false;

        if (!$match) {
            if (this.selectedDriver) {
                this.selectedDriver.vehicle = null;
                this.selectedDriver.currentAssignment = null;
            }
            this.currentAssignment = null;

            this.updateAssignmentChangedState();
            this.verifyData(true);
            return;
        }

        const newVehicle = this.vehicleService.findVehicle(this.vehicles, $match.objectId);

        let activeAssignment = this.driverAssignmentService.findAssignmentByVehicleId(this.assignments, newVehicle.Id);

        if (activeAssignment) {
            this.driverName = this.driverService.findDriver(this.displayDrivers, activeAssignment.DriverId).DisplayName;
            this.vehicleAssigned = true
        }

        this.selectedDriver.vehicle = newVehicle;

        if (!this.currentAssignment || this.originalAssignment && newVehicle.Id != this.originalAssignment.VehicleId) {
            newData = true;
            this.currentAssignment = copy(this.originalAssignment);
        }

        this.updateCurrentAssignmentModel();
        this.verifyData(newData);
    }

    showImageCacheInfoDialog() {
        const title = this.translationService.t("driverAssignment.driverImageChange");
        const message = this.translationService.t("driverAssignment.driverImageChangeContent");
        this.messageDialogService.handleInfoMessage(title, message);
    }


    private assignDriverGroupIds() {
        this.selectedDriver.GroupIds = [];

        this.groups.forEach(group => {
            if (group.DriverIds.find(id => id === this.selectedDriver.Id)) {
                this.selectedDriver.GroupIds.push(group.Id);
            }
        });
    }

    private createDefaultAssignmentModel() {
        this.currentAssignment = {
            AssignmentSource: DriverAssignmentSource.ManualAssignment,
            StartUtc: moment(),
            EndUtc: this.driverAssignmentService.getAssignmentPermanentDate(),
            DriverId: this.selectedDriver && this.selectedDriver.Id
        };
    }

    private createTableRows() {
        this.tableRows = [];

        this.displayDrivers.forEach(driver => {
            this.tableRows.push({
                data: driver,
                cells: this.createTableCells(driver)
            });
        });
    }

    private createTableCells(driver: IDriver): IVeriTableRowCell[] {
        const cells: IVeriTableRowCell[] = [
            this.veriTableService.createVehicleRegCell(driver.vehicle),
            {
                contents: driver.DisplayName,
                className: "bold"
            },
            {
                contents: driver.ButtonId,
                //className: "bold"
            },
            {
                contents: this.driverAssignmentService.getAssignmentEndLabel(driver.currentAssignment),
                sortData: driver.currentAssignment ? driver.currentAssignment.EndUtc : null
            },
            this.veriTableService.createDriverResourceGroupDisplayCell(driver),
            {
                contents: driver.externalReferences ? driver.externalReferences.map(m => m.ExternalReference).join() : ""
            },
            {
                contents: driver.Username
            },
            {
                contents: driver.Nfc
            }
        ];

        return cells;
    }

    private loadData(invalidateCache: boolean = false): angular.IPromise<void> {
        this.cancelChanges = false;
        this.loading = true;
        const driversPromise = this.driverService.getDrivers({ invalidateCache, includeTags: true });
        const groupPromise = this.groupService.getGroupsWithFullMappings(invalidateCache);
        const vehiclesPromise = this.vehicleService.getVehicles({ includePeripheralMappings: true, invalidateCache });
        const assignmentsPromise = this.driverAssignmentService.getDriverAssignments(true, invalidateCache);
        const externalRefPromise = this.externalReferenceService.getAllDriverExternalReferences(invalidateCache);
        const geofencesPromise = this.geofenceService.getGeofences();

        return this.$q
            .all([driversPromise, vehiclesPromise, groupPromise, assignmentsPromise, externalRefPromise, geofencesPromise])
            .then(([drivers, vehicles, groups, assignments, externalReferenceList, geofences]) => {
                this.vehicles = vehicles;
                this.displayDrivers = drivers;
                this.groups = groups;
                this.geofences = geofences;
                this.assignments = assignments;

                this.displayDrivers.forEach(driver => {
                    driver.externalReferences = externalReferenceList.filter(ref => ref.DriverId === driver.Id);
                });
                assignments.forEach(assignment => {
                    const driver = this.driverService.findDriver(this.displayDrivers, assignment.DriverId);

                    if (driver) {
                        driver.vehicle = this.vehicleService.findVehicle(this.vehicles, assignment.VehicleId);
                        driver.currentAssignment = assignment;

                        assignment.isPermanent = this.driverAssignmentService.assignmentIsPermanent(assignment);
                    }
                });
            })
            .catch(err => {
                this.messageDialogService.handleError(err, this.translationService.t("driverAssignment.UnableToLoad"))
            })
            .finally(() => {
                this.createTableRows();

                this.loading = false;
            });
    }

    private reset() {
        this.selectedDriver = null;
        this.currentAssignment = null;
        this.originalAssignment = null;
        this.setImageHasChanged(false);

        this.endDateType = 0;
        this.updateUIEndDatesFromAssignment();
    }

    private updateCurrentAssignmentModel() {
        if (!this.currentAssignment) {
            this.createDefaultAssignmentModel();
        }

        if (this.currentAssignment) {
            this.currentAssignment.VehicleId = this.selectedDriver.vehicle.Id;

            this.currentAssignment.isPermanent = this.driverAssignmentService.assignmentIsPermanent(this.currentAssignment);
        }

        this.updateAssignmentChangedState();
        this.updateUIEndDatesFromAssignment();

        this.updateAssignmentTranslations(this.currentAssignment);
    }

    private updateAssignmentTranslations(currentAssignment: IVehicleDriverMapping): void {
        currentAssignment.assignmentSourceLabel = (DriverAssignmentSource[currentAssignment.AssignmentSource])
            ? this.translationService.tEnum(DriverAssignmentSource, "DriverAssignmentSource", currentAssignment.AssignmentSource)
            : this.translationService.t("Common.Unknown");
    }

    private updateAssignmentChangedState() {

        this.assignmentChanged = !this.driverAssignmentService.assignmentsAreSame(this.currentAssignment, this.originalAssignment);
        this.assignmentChanges = [];

        if (!this.assignmentChanged) {
            return;
        }

        // Same vehicle, different date
        if (this.originalAssignment && this.currentAssignment && this.originalAssignment.VehicleId == this.currentAssignment.VehicleId) {
            if (this.currentAssignment.EndUtc.isSame(this.driverAssignmentService.getAssignmentPermanentDate())) {
                this.assignmentChanges.push(this.translationService.t(`driverAssignment.settingToPermanent`));
            }
            else {
                this.assignmentChanges.push(this.translationService.t(`driverAssignment.changingEndDate`, this.veriDate.formatDate(this.currentAssignment.EndUtc)));
            }
        }
        // Different vehicle
        else {
            if (this.originalAssignment) {
                const targetVehicle = this.vehicleService.findVehicle(this.vehicles, this.originalAssignment.VehicleId);
                this.assignmentChanges.push(this.translationService.t(`driverAssignment.endAssignmentTo`, targetVehicle.Reg));
            }

            if (this.currentAssignment) {
                const targetVehicle = this.vehicleService.findVehicle(this.vehicles, this.currentAssignment.VehicleId);
                let startAssignmentText = this.translationService.t(`driverAssignment.startAssignmentTo`, targetVehicle.Reg);
                this.driverAssignmentService.getAssignmentsByVehicleForTime(this.currentAssignment.VehicleId, moment())
                    .then((vehicleDriverMappings) => {
                        if (vehicleDriverMappings && vehicleDriverMappings.length) {
                            const driver = this.driverService.findDriver(this.displayDrivers, vehicleDriverMappings[0].DriverId);
                            const driverName = driver ? driver.DisplayName : this.translationService.t(`driverAssignment.anotherDriver`);
                            startAssignmentText += this.translationService.t(`driverAssignment.willDeassign`, driverName);
                        }
                        this.assignmentChanges.push(startAssignmentText);
                    })
                    .catch(err => {
                        this.messageDialogService.handleError(err, this.translationService.t("driverAssignment.UnableToGetAssignments"))
                    });
            }
        }

        this.verifyData();
    }

    private updateUIEndDatesFromAssignment() {

        this.endDate = new Date();
        this.endTime = new Date();

        if (this.currentAssignment /*&& !this.currentAssignment.isPermanent*/ /*this.driverAssignmentService.assignmentIsPermanent(this.currentAssignment)*/) {

            var endMoment = moment(this.currentAssignment.EndUtc);
            this.endDate = endMoment.toDate();
            this.endTime = endMoment.toDate();
        }

        this.endTime.setSeconds(0);
        this.endTime.setMilliseconds(0);

        this.updateEndDateType();
    }

    private updateEndDateType() {
        this.endDateType = 0;

        if (this.selectedDriver && this.currentAssignment && !this.currentAssignment.isPermanent) {
            this.endDateType = 1;
        }
    }

    verifyData(dataIsDirty = false): void {
        let formIsPending = false;
        let formIsDirty = false;
        this.driverFormInvalid = false;

        if (this.editDriverForm) {
            this.driverFormInvalid = this.editDriverForm.$invalid;
            formIsPending = !!this.editDriverForm.$pending;
            formIsDirty = dataIsDirty ? true : this.editDriverForm.$dirty;
        }

        this.dataChanged = this.imageHasChanged || formIsDirty;
        this.allowSave = !this.saving && !formIsPending && this.dataChanged && !this.driverFormInvalid;
    }

    private setImageHasChanged(value: boolean): void {
        this.imageHasChanged = value;
    }
}

export class DriversComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            onDriversChanged: "&"
        };

        this.controller = DriversComponentController;
        this.template = require(`./driverassignment.html`);
    }
}
